<template>
  <div>
    <base-header class="pb-6 bg-pulse-blue">
      <b-row align-v="center" class="py-4">
        <b-col cols="7" lg="6">
          <h6 class="h2 text-white d-inline-block mb-0">Pulse Users</h6>
        </b-col>
      </b-row>
    </base-header>
    <b-container fluid class="mt--6">
      <b-card no-body>
        <b-card-header>
          <h3 class="mb-0">Pulse Users</h3>
        </b-card-header>
        <b-table responsive small :items="users" :fields="fields" :perPage="pagination.perPage" :sort-by.sync="sortBy">
          <template #cell(annual_goals)="row">
            <i class="fas fa-check text-success" v-if="row.item.annual_goals"></i>
          </template>
        </b-table>
        <div
          slot="footer"
          class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
        >
          <div class="">
            <p class="card-category">
              <!-- Showing {{ pagination.from }} to {{ pagination.to }} of {{ pagination.total }} entries -->

              <span v-if="selectedRows.length">
                &nbsp; &nbsp; {{selectedRows.length}} rows selected
              </span>
            </p>

          </div>
          <base-pagination
            class="pagination-no-border"
            :current="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="pagination.total"
            @change="paginationChanged($event)"
          >
          </base-pagination>
        </div>
      </b-card>
    </b-container>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import { BasePagination } from '@/components';
import paginationMixin from '@/views/Components/Tables/PaginatedTables/paginationMixin';

export default {
  mixins: [paginationMixin],
  components: {
    BasePagination
  },
  data() {
    return {
      users: null,
      loading: true,
      selectedRows: [],
      propsToSearch: [],
      sortBy: 'name',
      sortDesc: false,
      fields: [
        {
          key: 'name',
          sortable: true
        },
        {
          key: 'email',
          sortable: true
        },
        {
          key: 'phone',
          sortable: true
        },
        {
          key: 'points',
          sortable: true
        },
        {
          key: 'annual_goals',
          sortable: true
        },
        {
          key: 'last_login',
          sortable: true
        }
      ],
    }
  },
  computed: {
    ...mapGetters({
      userRoute: 'profile/userRoute'
    })
  },
  methods: {
    getPulseUsers() {
      axios.get(process.env.VUE_APP_API_BASE_URL + "/pulse/users")
      .then(response => {
        this.users = response.data;
        this.loading = false;
      })
      .catch(error => {
        // 
      });
    },
    selectionChange(selectedRows) {
      this.selectedRows = selectedRows
    },
  },
  mounted() {
    document.title = 'Pulse Users | ClarityNOW';
  },
  created() {
    this.getPulseUsers();
  }
};
</script>
<style lang="scss">
.bg-pulse-blue {
  background-color: #262262!important;
}
</style>